import { RootState } from 'store/rootReducer';

export const LandingPageContentSelector = (state: RootState) => state.content.landingPage;
